<div class="fields">
    <div class="field" [ngClass]="{ inline: isInline, 'full-width': size === 'full' }">
        <div
            class="field__header"
            [ngClass]="{
                'field__header--display-second': shouldDisplayContentFirst,
                'field__header--always-visible': alwaysShowHeader
            }"
        >
            <label [ngClass]="{ 'field__label--secondary-color': isSecondaryLabel }">
                {{ label }}
                <ng-content select="wizard-tooltip, dg-tooltip, .wizard-tooltip"></ng-content>
            </label>
            <ng-content select=".toggle-container"></ng-content>
        </div>

        <!-- to use paired styling, ng-content must contained a .field/label--paired-container element -->
        <div
            class="{{ size || 'medium' }} field__content"
            [ngClass]="{ 'field__content--display-first': shouldDisplayContentFirst }"
        >
            <ng-content></ng-content>
        </div>
    </div>
</div>
